<template>
  <div class="topic-invite-via-email-container">
    <div class="topic-invite-via-email-container__body">
      <p class="topic-invite-via-email-container__body--title">
        {{ module === 'shareFeedPost' ? 'Share Post via Email' : 'Invite Contacts via Email'}}
      </p>
      <div class="topic-invite-via-email-container__body--input-field">
        <tagify-email
          :placeholder="isSharedPost ? 'Share via email' :  'Invite via email'"
          @addEmail="addEmail"
          @removeEmail="removeEmail"
          :isSubmitted="isSubmit"
          :nullify="emptyTagifyInput"
          />
      </div>
      <div class="email-invited-users">
        <div class="email-invited-users__header">
          <h1 class="email-invited-users__header--title">
            {{isSharedPost ? `Users: ${selectedEmailsList.length}` : `Contacts: ${selectedEmailsList.length}`}}
          </h1>
        </div>
        <div class="email-invited-users__body">
          <!-- <p class="message">No members selected</p> -->
            <div v-for="selectedUser in selectedEmailsList" :key="selectedUser.email" class="email-invited-users__body--user-card">
              <div class="email-invited-users__body--user-card--image">
                <img
                  src="https://nyc3.digitaloceanspaces.com/imagespictures/media/profile_photo/default.png"
                  alt="Image"
                />
              </div>
              <div class="email-invited-users__body--user-card--content">
                <div class="email-invited-users__body--user-card--content--name">
                  <h1>{{ selectedUser.email }}</h1>
                </div>
                <a-select
                  v-if="showRoleOptions"
                  class="email-invited-users__body--user-card--content--select"
                  v-model:value="selectedUser.role"
                  :options="roleOptions"
                ></a-select>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TagifyEmail from "../../PdbComponents/TagifyEmail.vue";

export default {
  data() {
    return {
      roleOptions: [
        { label: "Admin", value: "admin" },
        { label: "Contributor", value: "contributor" },
        { label: "Editor", value: "editor" },
      ],
      isSubmit:false,
      emptyTagifyInput:false,
      selectedEmails: new Map()
    };
  },
  props:{
    module: {
      type: String,
      default: () => ('AddTopicModule')
    },
    topicType:{
      type: String,
      default: () => ('private')
    }
  },
  components: {
    TagifyEmail,
  },
  computed:{
    selectedEmailsList(){
      return Array.from(this.selectedEmails.values())
    },
    showRoleOptions(){
      return this.module === 'TopicManagement' || ( this.module === 'AddTopicModule' && this.topicType === 'private') || (this.module === 'InviteTopicCollaboration' && this.topicType === 'private')
    },
    isSharedPost(){
      return this.module === 'shareFeedPost'
    }
  },
  watch:{
    selectedEmails:{
      handler(data){
        this.emitToParent(data)
      }, deep:true
    }
  },
  mounted(){
    this.emitter.on('clear-topic-invited-emails', ()=>{
      this.clearAll()
    })
  },
  methods:{
    addEmail(email) {
      // this.selectedEmails = emails;
      this.selectedEmails.set(email, {email, role:'contributor'})
    },
    removeEmail(email) {
      // this.selectedEmails = emails;
      this.selectedEmails.delete(email)
    },
    emitToParent(data){
      this.$emit('changeSelectedUsers', Array.from(data.values()))
    },
    clearAll(){
        this.emitter.emit('clear-tagify-emails')
        this.selectedEmails = new Map()
    }
  }
};
</script>

<style lang="scss">
.topic-invite-via-email-container {
  margin-bottom: 2.5rem;
  &__body {
    &--title {
      font-size: 1.6rem;
      font-family: $font-primary-medium;
      font-weight: 500;
      margin-bottom: 1rem;
      line-height: 2.2rem;
      width: fit-content;
      color: $color-black;
    }
    &--input-field {
      .tagify {
        font-size: 1.4rem;
        font-family: $font-primary;
        &__input {
          padding: 1rem 1rem;
          font-size: 1.4rem;
          &::before {
            max-width: 87%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            color: #949494;
          }
        }
        &__tag {
          display: flex;
          align-items: center;
          margin: 0.4rem 0 0.2rem 0.5rem;
          background-color: #e5e5e5;
          border-radius: 0.5rem;
          padding-right: 0.5rem;
          &:hover,
          &:focus {
            box-shadow: none;
            background-color: #cfd7ef;
          }
          .tagify__tag__user {
            .tagify__tag__avatar-wrap {
              width: 2.6rem;
              height: 2.4rem;
            }
            .tagify__tag-text {
              font-size: 1.4rem;
              line-height: 2rem;
            }
            &::before {
              background-color: transparent;
            }
          }
        }
      }
    }
    .email-invited-users {
      margin-top: 2rem;
      padding-bottom: 2rem;
      margin-bottom: 3rem;
      border-bottom: 1px solid #cdcdcd;
      &__header {
        &--title {
          font-size: 1.4rem;
          font-family: $font-primary-medium;
          line-height: 2.2rem;
          margin-bottom: 1.8rem;
          color: $color-black;
          opacity: 0.6;
        }
      }
      &__body {
        width: 100%;
        display: flex;
        flex-direction: column;
        gap: 1.5rem;
        .message {
          font-size: 1.4rem;
          text-align: center;
          font-family: $font-primary;
          display: block;
          margin: 0 auto 2rem;
          opacity: 0.8;
        }
        &--user-card {
          display: flex;
          align-items: center;
          gap: 0.8rem;
          width: 100%;
          &--image {
            width: 4rem;
            height: 4rem;
            overflow: hidden;
            border-radius: 100%;
            img {
              background-color: #80808040;
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          &--content {
            display: flex;
            align-items: center;
            gap: 0.8rem;
            width: calc(100% - 5.3rem);
            &--name {
              display: flex;
              align-items: flex-start;
              flex-direction: column;
              gap: 0.4rem;
              h1 {
                font-size: 1.6rem;
                font-family: $font-primary-medium;
                line-height: normal;
                margin-bottom: 0;
                color: $color-black;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 1; /* number of lines to show */
                line-clamp: 1;
                -webkit-box-orient: vertical;
              }
              .pending {
                background-color: #ec424226;
                color: #ec4242;
              }
              .active {
                background-color: #0080003b;
                color: green;
              }
            }
            &--select {
              margin-left: auto;
              box-shadow: none;
              .ant-select-selector {
                height: 3rem !important;
                background-color: $color-primary;
                border: none;
                font-size: 1.4rem;
                line-height: normal;
                color: $color-white;
                padding: 0 1.5rem;
                box-shadow: none !important;
                border-radius: 0.5rem !important;
                font-family: $font-primary-medium;
                .ant-select-selection-search {
                  right: 2.6rem;
                  .ant-select-selection-search-input {
                    height: 100%;
                  }
                }
                .ant-select-selection-item {
                  font-size: 1.2rem;
                  padding-right: 2rem;
                  line-height: normal;
                }
              }
              .ant-select-arrow {
                right: 1.5rem;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                .anticon {
                  color: $color-white;
                  font-size: 1.1rem;
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>
